/**
 * The front door: /landing (a stand-in for 4klabs.ai with the prompt box) and /start (the storyboard view and
 * sign-in). Built in only where the build sets VITE_FRONT_DOOR=true: today the beta case of
 * scripts/aws-infra/deploy-frontend.sh. Off, both pages send to sign-in and every other route is unchanged.
 */
export const frontDoorOn = (): boolean => import.meta.env.VITE_FRONT_DOOR === 'true';
